
import { TextArea } from "components/Forms/TextArea";
import { useLocalisationService } from 'providers/LocalisationProvider';

export const SummaryNotes = props => {
    const {incident, editingEnabled} = props;
    const l = useLocalisationService();

    const renderEditableNotes = () => {
        return <div className='flexbox summary-incident-notes'>
        <TextArea
            name="incident-notes"
            placeholder={l.getString("summary_incident_notes_placeholder")}
            defaultValue={incident.getNotes()}
            onChange={(v) => incident.setNotes(v)}
            maxLength={300}
          />
        </div>
    }

    const renderNotes = () => {
        return <div className="summary-incident-notes"><p>{incident.getNotes()}</p></div>
    }

    if(editingEnabled){
        return renderEditableNotes();
    }
    return  renderNotes();
}